"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledAnchor = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "LinkButton__StyledAnchor",
  componentId: "sc-1anago3-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    height: 50px;\n    min-height: 0;\n    font-size: 16px;\n    border-radius: 5px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0px 30px;\n    margin-right: 5px;\n    white-space: nowrap;\n    \n    :visited, :focus {\n        color: ", ";\n    }\n    \n    &.round {\n        border-radius: 30px;\n        height: 100%;\n        padding: 5px;\n    }\n"])), _Colors.white);

var LinkButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LinkButton, _Component);

  var _super = _createSuper(LinkButton);

  function LinkButton() {
    (0, _classCallCheck2.default)(this, LinkButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LinkButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          href = _this$props.href,
          round = _this$props.round,
          additionalProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "label", "href", "round"]);
      var computedClassNames = (0, _classnames.default)('btn btn-primary', className, {
        'round': round
      });
      return /*#__PURE__*/_react.default.createElement(StyledAnchor, (0, _extends2.default)({
        href: href,
        className: computedClassNames
      }, additionalProps), label);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        className: _propTypes.default.string,
        label: _propTypes.default.any.isRequired,
        href: _propTypes.default.string.isRequired,
        round: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        className: ''
      };
    }
  }]);
  return LinkButton;
}(_react.Component);

exports.default = LinkButton;